import { h, JSX } from "@stencil/core";

const headerDetail = (
  type: "text" | "link" = "text",
  caption: string,
  description: string,
  callback?: () => void,
  cssClass?: string
): JSX.Element => {
  return (
    <div class={{ [cssClass]: true, "field field-block": true }}>
      <span class="detail__label body-semi-bold-s">{caption}</span>
      {type === "text" ? (
        <p class="body-regular-s">{description}</p>
      ) : (
        <button class="detail__link body-regular-s" onClick={callback}>
          {description}
        </button>
      )}
    </div>
  );
};
export default headerDetail;

export const headerTitle = (caption: string, cssClass?: string) => {
  return (
    <h2
      class={{ [cssClass]: true, "header__title subtitle-semi-bold-s": true }}
    >
      {caption}
    </h2>
  );
};

export const headerSubtitle = (caption: string, cssClass?: string) => {
  return (
    <p
      class={{ [cssClass]: true, "detail__title subtitle-semi-bold-xs": true }}
    >
      {caption}
    </p>
  );
};
